import {
  ArrowRight,
  Book,
  BookOpen,
  Bot,
  Braces,
  Brain,
  Calendar,
  ChartColumn,
  ChartLine,
  ChartNetwork,
  ChefHat,
  Circle,
  Cloud,
  Code,
  Computer,
  Copy,
  Database,
  Dot,
  FileCode,
  Fingerprint,
  FlaskConical,
  Gavel,
  GitBranch,
  Github,
  GraduationCap,
  Key,
  Layers,
  Link,
  List,
  ListChecks,
  Lock,
  Mail,
  MessagesSquare,
  Microchip,
  Microscope,
  Monitor,
  Pen,
  PenTool,
  Play,
  Plug,
  Puzzle,
  RadioTower,
  RefreshCw,
  Rocket,
  Route,
  Satellite,
  Scale,
  Server,
  Sliders,
  Sparkles,
  Tag,
  Tags,
  Target,
  Terminal,
  ToggleRight,
  Upload,
  Users,
  WandSparkles,
  Waypoints,
  Workflow,
  Wrench,
  Zap,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

const MINT_ICON_MAP = {
  flask: FlaskConical,
  "pen-nib": PenTool,
  fingerprint: Fingerprint,
  brain: Brain,
  server: Server,
  "satellite-dish": Satellite,
  database: Database,
  code: Code,
  tags: Tags,
  route: Route,
  rocket: Rocket,
  plug: Plug,
  bullseye: Target,
  pen: Pen,
  "chart-column": ChartColumn,
  "arrow-right": ArrowRight,
  wrench: Wrench,
  upload: Upload,
  "scale-balanced": Scale,
  microscope: Microscope,
  "kitchen-set": ChefHat,
  "chart-line": ChartLine,
  book: Book,
  terminal: Terminal,
  sparkles: Sparkles,
  "puzzle-piece": Puzzle,
  play: Play,
  github: Github,
  "file-code": FileCode,
  bolt: Zap,
  "arrows-rotate": RefreshCw,
  "signal-stream": RadioTower,
  robot: Bot,
  "list-check": ListChecks,
  calendar: Calendar,
  "wand-magic-sparkles": WandSparkles,
  "toggle-on": ToggleRight,
  list: List,
  "layer-group": Layers,
  "graduation-cap": GraduationCap,
  "book-open": BookOpen,
  waypoints: Waypoints,
  users: Users,
  tag: Tag,
  sliders: Sliders,
  microchip: Microchip,
  lock: Lock,
  link: Link,
  key: Key,
  "git-branch": GitBranch,
  gavel: Gavel,
  envelope: Mail,
  dot: Dot,
  "diagram-project": Workflow,
  desktop: Monitor,
  copy: Copy,
  computer: Computer,
  comments: MessagesSquare,
  cloud: Cloud,
  circle: Circle,
  "chart-network": ChartNetwork,
  "brackets-curly": Braces,
} satisfies Record<string, LucideIcon>;

type MintIconName = keyof typeof MINT_ICON_MAP;

export function renderMintIcon(name: string): ReactNode {
  const Icon = Object.hasOwn(MINT_ICON_MAP, name)
    ? MINT_ICON_MAP[name as MintIconName]
    : undefined;

  if (!Icon) {
    if (import.meta.env.DEV) {
      console.warn(`Unknown Mintlify icon: ${name}`);
    }

    return null;
  }

  return <Icon aria-hidden />;
}
